import { useEffect, useMemo, useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { cn } from '../../lib/utils';
import Maps from './Maps';
import StageOne from './TournamentStages/StageOne';
import StageTwo from './TournamentStages/StageTwo';
import PlayersTab from './tournament/PlayersTab';
import RulesTab from './tournament/RulesTab';
import { DEFAULT_MODE, getTournamentModes, modeLabel } from '../../constants/modes';

const BracketTournamentView = ({ tournament, players, tournamentId }) => {
  const tournamentModes = useMemo(() => getTournamentModes(tournament), [tournament]);
  const [mode, setMode] = useState(tournamentModes[0] || DEFAULT_MODE);

  useEffect(() => {
    if (tournamentModes.length > 0 && !tournamentModes.includes(mode)) {
      setMode(tournamentModes[0]);
    }
  }, [tournamentModes, mode]);

  return (
    <Tabs defaultValue="stages" className="w-full">
      <TabsList className="w-full justify-start overflow-x-auto">
        <TabsTrigger value="stages">Stages</TabsTrigger>
        {!tournament.hideMaps && <TabsTrigger value="maps">Maps</TabsTrigger>}
        <TabsTrigger value="rules">Rules</TabsTrigger>
        <TabsTrigger value="players">Players</TabsTrigger>
      </TabsList>

      <TabsContent value="stages" className="space-y-10">
        {tournamentModes.length > 1 && (
          <div className="flex items-center justify-center">
            <div className="inline-flex rounded-md border border-border/60 bg-background/40 p-0.5">
              {tournamentModes.map((m) => (
                <button
                  key={m}
                  type="button"
                  onClick={() => setMode(m)}
                  className={cn(
                    'px-4 py-1.5 font-mono text-xs font-medium uppercase tracking-[0.2em] transition-colors',
                    mode === m
                      ? 'bg-secondary text-foreground'
                      : 'text-muted-foreground hover:text-foreground'
                  )}
                >
                  {modeLabel(m)}
                </button>
              ))}
            </div>
          </div>
        )}

        <section>
          <div className="mb-4 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
            <span className="h-px w-6 bg-heat" />
            Group stage
          </div>
          <StageOne tournamentId={tournamentId} mode={mode} />
        </section>

        <section>
          <div className="mb-4 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
            <span className="h-px w-6 bg-heat" />
            Knockout stage
          </div>
          <StageTwo tournamentId={tournamentId} mode={mode} />
        </section>
      </TabsContent>

      {!tournament.hideMaps && (
        <TabsContent value="maps">
          <Maps tournamentId={tournamentId} />
        </TabsContent>
      )}

      <TabsContent value="rules">
        <RulesTab html={tournament.rules} />
      </TabsContent>

      <TabsContent value="players">
        <PlayersTab players={players} />
      </TabsContent>
    </Tabs>
  );
};

export default BracketTournamentView;
